import React from 'react'
import { isChunkLoadError } from 'helpers/chunkLoadRecovery'

type LazyModule<T extends React.ComponentType<any>> = {
 default: T
}

const retryDelay = (attempt: number) => new Promise((resolve) => setTimeout(resolve, attempt * 700))

export function lazyWithChunkRetry<T extends React.ComponentType<any>>(
 load: () => Promise<LazyModule<T>>,
 maxRetries = 2
): React.LazyExoticComponent<T> {
 return React.lazy(async () => {
 let lastError: unknown

 for (let attempt = 0; attempt <= maxRetries; attempt += 1) {
 try {
 return await load()
 } catch (error) {
 lastError = error
 if (!isChunkLoadError(error) || attempt === maxRetries) {
 throw error
 }
 await retryDelay(attempt + 1)
 }
 }

 throw lastError
 })
}
